module.exports = __webpack_public_path__ + "img/asterisk-01.5bde463a.svg";